"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgHelpCircle = function SvgHelpCircle(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24 13c6.075 0 11 4.925 11 11s-4.925 11-11 11-11-4.925-11-11 4.925-11 11-11zm0 2a9 9 0 100 18 9 9 0 000-18zm0 12a1 1 0 110 2 1 1 0 010-2zm.596-8.947A4 4 0 0127.92 22c0 1.28-.758 2.29-1.945 3.082a7.575 7.575 0 01-1.739.867 1 1 0 11-.632-1.898 5.988 5.988 0 001.262-.633c.687-.459 1.054-.948 1.054-1.42a2 2 0 00-3.887-.666 1 1 0 11-1.886-.664 4 4 0 014.45-2.615z",
    id: "help-circle_svg__a"
  }));
};

var _default = SvgHelpCircle;
exports["default"] = _default;